import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { installMockApi } from "./mocks";
import "./index.css";

// Backend olmadan da çalışsın diye mock API'yi fetch üzerine kur.
// Gerçek sunucuya bağlanmak için: VITE_USE_MOCKS=false ve VITE_API_BASE ayarlayın.
installMockApi();

createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);